module.exports = __webpack_public_path__ + "img/logo.0ef840fc.png";